import { render, staticRenderFns } from "./TrainingTrainingsDetails.vue?vue&type=template&id=55c36fbf&"
import script from "./TrainingTrainingsDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingTrainingsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports